export const USERNAME_MIN_LEN = 5;
export const USERNAME_MAX_LEN = 20;

// Mirrors UsernameController.RESERVED on the backend. Prefix/suffix matching
// applies to words of 5+ characters, exact matching to all of them.
export const USERNAME_RESERVED = new Set([
  'admin', 'sorteia', 'sorteio', 'oficial', 'official',
  'suporte', 'support', 'staff', 'equipe', 'mod', 'moderador', 'bot',
  'sistema', 'system', 'root', 'owner', 'vgmable', 'ajuda', 'help',
  'security', 'seguranca', 'anonimo', 'deletado',
  'test', 'teste', 'demo', 'null', 'undefined', 'empty',
  'porra', 'caralho', 'merda', 'foda', 'foder', 'viado', 'bicha',
  'puta', 'putaria', 'puto', 'buceta', 'cuzao', 'piroca', 'pinto',
  'vagabundo', 'vagabunda', 'otario', 'otaria', 'arrombado', 'escroto',
  'fdp', 'vsf', 'krl',
  'macaco', 'negao', 'neguinho', 'japa', 'gringo', 'judeu', 'traveco',
  'betano', 'blaze', 'sportingbet', 'betfair', 'pixbet', 'kto',
  'betnacional', 'estrelabet',
]);

export function validateUsername(raw: string): { ok: true; lower: string } | { ok: false; code: string } {
  const value = raw.trim();
  if (value.length < USERNAME_MIN_LEN) return { ok: false, code: 'too_short' };
  if (value.length > USERNAME_MAX_LEN) return { ok: false, code: 'too_long' };
  if (!/^[A-Za-z]/.test(value)) return { ok: false, code: 'first_char' };
  if (!/^[A-Za-z][A-Za-z0-9_.]*$/.test(value)) return { ok: false, code: 'invalid_char' };
  if (/[._]{2,}/.test(value)) return { ok: false, code: 'consecutive_special' };
  if (/[._]$/.test(value)) return { ok: false, code: 'trailing_special' };
  const lower = value.toLowerCase();
  if (USERNAME_RESERVED.has(lower)) return { ok: false, code: 'reserved' };
  for (const word of USERNAME_RESERVED) {
    if (word.length >= 5 && (lower.startsWith(word) || lower.endsWith(word))) return { ok: false, code: 'reserved' };
  }
  return { ok: true, lower };
}
